
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import EditBoardForm from "./EditBoardForm";
import { useBoards } from "@/contexts/boards";
import { useEffect } from "react";

const EditBoardDialog = () => {
  const { operation, closeOperation, handleBoardUpdated } = useBoards();
  
  const isOpen = operation.isOpen && operation.type === "edit";
  const board = operation.board;

  // Log dialog state for debugging
  useEffect(() => {
    console.log("Edit dialog state:", { isOpen, board });
  }, [isOpen, board]);

  if (!board) {
    return null;
  }

  const handleComplete = () => {
    console.log('[EditBoardDialog] handleComplete called');
    closeOperation();
    handleBoardUpdated();
    
    // TEMPORARY FIX: Force page refresh after dialog closes
    setTimeout(() => {
      console.log('[EditBoardDialog] Forcing page refresh');
      window.location.reload();
    }, 100);
  };

  const handleOpenChange = (open: boolean) => {
    console.log('[EditBoardDialog] handleOpenChange called with:', open);
    if (!open) {
      closeOperation();
      
      // TEMPORARY FIX: Force page refresh when dialog is closed
      setTimeout(() => {
        console.log('[EditBoardDialog] Forcing page refresh after dialog close');
        window.location.reload();
      }, 100);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold">Edit Board</DialogTitle>
          <DialogDescription>
            Update your board details below
          </DialogDescription>
        </DialogHeader>
        <EditBoardForm
          boardId={board.id}
          initialTitle={board.title}
          initialDescription={board.description || ""}
          initialColor={board.color || undefined}
          onComplete={handleComplete}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditBoardDialog;
